import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "uxp-other-topics"
    }}>{`UXP: Other Topics`}</h1>
    <p>{`UXP is a growing technology platform and, as such, has many different facets. Here are topics you may need to know to successfully create a UXP plugin:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./manifest-v4/"
        }}>{`The UXP Manifest`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./localization-and-platforms/"
        }}>{`Localization and Platforms`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./flyout-menus/"
        }}>{`Flyout Menus`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./file-access/"
        }}>{`File Access`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./network-io/"
        }}>{`Network I/O`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./spectrum-css/"
        }}>{`Spectrum CSS`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      